import React, { useEffect, useState } from "react";
import CardsTable from "./components/CardsTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider/index";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";

function Cards() {
  const token = useSelector((state) => state.auth.token);
  const [cards, setCards] = useState([]);
  const [chooseCardId, setChooseCardId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteCardsIds, setDeleteCardsIds] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    number: "",
    status: "",
  
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onCards = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
        status,
      number,
      name,
      
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}card?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${name ? `&name=${name}` : ""}${number ? `&number=${number}` : ""}${status ? `&status=${status}` : ""}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setCards(content);
        setIsError(false);
        setCount(totalElements)
        
      })
      .catch(() => {
        setIsLoading(false);
        setCards([]);
        setIsError(true);
      });
  };

  const onCardChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}card/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onCards(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Kartlar</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <CardsTable
        cards={cards}
        isLoading={isLoading}
        isError={isError}
        setChooseCardId={setChooseCardId}
        setOpenView={toggleDrawer(true)}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteCardsIds={setDeleteCardsIds}
        deleteCardsIds={deleteCardsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onCards={onCards}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onCardChoose={onCardChoose}
          chooseCardId={chooseCardId}
        />
      )}

      {showRemove && (
        <Delete
          id={chooseCardId}
          show={showRemove}
          onHide={setShowRemove}
          onCards={onCards}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}

        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onCards={onCards}
          chooseCardId={chooseCardId}
          onCardChoose={onCardChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}

      />
     
    </div>
  );
}

export default Cards;
